import { Box } from '@mui/material';
import React, { useState } from 'react';
import InlineSVG from 'react-inlinesvg';
import { useDispatch, useSelector } from 'react-redux';

import assets from '../../assets';
import redux, { RootState } from '../../redux';
import ConditionalCustomerGroup from './conditional-customer-group';
import CustomerSpan from './customer-span';
import './group-switcher.css';
import GroupSwitcherSkeleton from './group-switcher-skeleton';
import SelectionPopover from './selection-popover';

const caretDownStyle = {
  marginLeft: 16,
};

function GroupSwitcher() {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const dispatch: typeof redux.store.dispatch = useDispatch();
  const isLoading = useSelector((state: RootState) => state.api.isLoading);
  const isError = useSelector((state: RootState) => state.api.isError);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!isLoading && !isError) {
      dispatch(redux.modal.open());
      setAnchorEl(event.currentTarget);
    }
  };

  return (
    <>
      <Box
        className="group-switcher-wrapper"
        data-testid="group-switcher-wrapper"
        onClick={handleClick}
        sx={{ cursor: isLoading ? 'initial' : 'cursor' }}
      >
        {!isLoading && !isError && (
          <Box className="group-switcher">
            <InlineSVG src={assets.icons.customer} />
            <CustomerSpan />
            <ConditionalCustomerGroup />
          </Box>
        )}
        {(isLoading || isError) && <GroupSwitcherSkeleton />}
        <InlineSVG src={assets.icons.caretDown} style={caretDownStyle} />
      </Box>
      <SelectionPopover anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
    </>
  );
}

export default GroupSwitcher;
